import React, { useState } from 'react';

import { Button } from '@/components/ui/button';
import { useGetMatterCompanionsQuery } from '@/services/api/mattersService';

import { ManageCompanionsModal } from './ManageCompanionsModal';
import { MatterSectionCard } from './MatterSectionCard';

interface RelatedMattersProps {
  matterId: string;
}

export const RelatedMatters: React.FC<RelatedMattersProps> = ({ matterId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: companions } = useGetMatterCompanionsQuery(matterId, {
    skip: !matterId,
  });

  const hasGroup = Boolean(companions && companions.members.length > 1);

  return (
    <>
      <MatterSectionCard
        title="Related Cases"
        headerActions={
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsModalOpen(true)}
            className="h-7 px-2 text-xs text-primary hover:text-primary/80"
          >
            {hasGroup ? 'Manage' : 'Link cases'}
          </Button>
        }
      >
        {hasGroup ? (
          <p className="text-sm text-zinc-700">
            {companions?.members.length ?? 0} related{' '}
            {companions?.members.length === 1 ? 'case' : 'cases'}
          </p>
        ) : (
          <p className="text-sm text-zinc-500">No related cases linked</p>
        )}
      </MatterSectionCard>

      <ManageCompanionsModal
        matterId={matterId}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
